<!-- =========================================================================================
  File Name: StudentSettingSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ $t('student.setting.title') }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
      <label>Max Daily Logins</label> <span>
        &nbsp;
        <vs-button v-if="dataMaxDailyLogins!='0'" size="small" >{{dataMaxDailyLogins}}</vs-button>
        <vs-button v-else size="small" >N/A</vs-button>
        </span>
        &nbsp;<vs-button v-if="dataMaxDailyLogins>0" @click="removeLimitaction()" size="small" class="danger">Remove Limit</vs-button>
        <vs-slider :max="10" :min="1" v-model="dataMaxDailyLogins" />
     </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import {GET_STUDENT_SETTING_DETAILS, UPDATE_STUDENT_SETTING,REMOVE_STUDENT_SETTING} from "@/graphql";

export default {
  props: {
    isSettingSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment
  },
  data () {
    return {
      dataId: null,
      dataPrice: 0,
      removeLimit:false,
      dataMaxDailyLogins: '0',
      StudentSettingId:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
      isSettingSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.initValues()
        this.getCameraSettingData(this.dataId)

      }
      }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSettingSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataMaxDailyLogins
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataMaxDailyLogins='0'
      this.removeLimit=false

      },
    removeLimitaction(){
      this.removeLimit=true
      this.dataMaxDailyLogins ='0'

    },
    getCameraSettingData(id) {
         this.$apollo
        .mutate({
          mutation: GET_STUDENT_SETTING_DETAILS,
          variables: {
            id:  id
          },
        })
        .then(response => {
          if(response.data.getStudentSettingData.daily_logins !=null){
            if(response.data.getStudentSettingData.status=='SUCCESS' && response.data.getStudentSettingData.daily_logins !='0'){
              this.dataMaxDailyLogins = response.data.getStudentSettingData.daily_logins
              this.StudentSettingId=response.data.getStudentSettingData.setting_id
            }
            else {
              this.dataMaxDailyLogins = '0'
              this.removeLimit=true
            }
          }
          else {
            this.dataMaxDailyLogins = '0'

          }
        })
    },
    submitData () {
      if(this.removeLimit==true && this.dataMaxDailyLogins=='0')
      {
           this.$apollo
           .mutate({
            mutation: REMOVE_STUDENT_SETTING,
          variables: {
            id: this.StudentSettingId
          },
        })
        .then(response => {
          this.successNotificationUpdate()
           this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
      })
      }
      else{
        this.$apollo
          .mutate({
            mutation: UPDATE_STUDENT_SETTING,
            variables: {
              id: this.dataId,
              max_logins: this.dataMaxDailyLogins
            }
          }).then(response => {
          if (response.data.updateStudentSetting.status == "SUCCESS") {
            this.successNotificationUpdate()
             this.$emit('closeSidebar')
             this.$validator.reset()
             this.initValues()
          } else if (response.data.updateStudentSetting.status == "UPDATED") {
            this.successNotificationUpdate()
              this.$emit('closeSidebar')
             this.$validator.reset()
             this.initValues()
          }
        })
      }
    },
    successNotificationUpdate() {
      this.$vs.notify({
        title: 'Setting',
        text: 'Saved successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
